import { Textual }	from "@v3/data/textual";

export type HexColor	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"HexColor",
		/^#[a-f0-9]{6}$/,
		"must be a # sign followed by 6 hexadecimal characters"
	);

namespace Extension {
	export const black	= Base.brand("#000000");
	export const white	= Base.brand("#ffffff");
}

export const HexColor	= { ...Extension, ...Base };
